import React from "react";
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {

    return (
        <div className="footerWork h-auto  md:h-[22rem] mt-32 " style={{ backgroundColor: "#0A160D", color: "#ffff" }}>
            <div className="marginClass py-14">
                <div className="md:flex md:gap-[2rem] lg:gap-[3rem]  xl:gap-[4rem] 2xl:gap-[7rem] ">
                    <div className="  xl:w-[22rem]">
                        <div className="flex items-center gap-[1rem]">
                            <div className="h-[60px] w-[60px]">
                                <img src="assets/logo.png" className="h-[100%] w-[100%]" />

                            </div>
                            <h5 style={{ color: "#ffff" }}  > Quran App</h5>
                        </div>
                        <p style={{ width: "16rem" }}>
                            As praying to God in the defined intervals each day in Islamic religion with reciting of ayah and get the blessings of Allah
                        </p>
                        <div className="flex mt-8 gap-[1rem] items-center">
                            <span> Download App on</span>
                            <a href="https://apps.apple.com/in/app/uzbek-quran/id1143934624">
                                <div style={{ border: "#009000 solid 1px", borderRadius: "13px", padding: "10px" }}>
                                    <img src="assets/appleWhite.svg" className="h-[10px] w-[10px]" />
                                </div>
                            </a>
                            <div style={{ border: "#009000 solid 1px", borderRadius: "13px", padding: "10px" }}>
                                <img src="assets/playstorelogo.svg" className="h-[10px] w-[10px]" />
                            </div>

                        </div>
                    </div>



                    <div className="lg:w-[15rem] mt-12 md:mt-0">
                        <h6>Quick Links</h6>
                        <Link to='terms-and-conditions' style={{ fontSize: "12px" }}>Terms & Conditions</Link>
                        <br></br>
                        <Link to='privacy-policy' style={{ fontSize: "12px" }} className=" mt-0 md:mt-3 lg:mt-0">Privacy Policy </Link>

                    </div>
                    <div className="mt-12 md:mt-0 ">
                        <h6>Contact</h6>
                        <div style={{ cursor: "pointer" }} className="flex items-center gap-[15px] ml-[5px] md:ml-[5px]  lg:ml-[5px] mb-[1rem] md:mb-[0rem]">
                            <div>
                                <img src="assets/mail.svg" />
                            </div>
                            <div >
                                <a href="mailto:support@quranpoint.com" >
                                    <p  >support@quranpoint.com</p>
                                </a>
                            </div>

                        </div>
                        <div className="flex items-center gap-[15px] mt-0 md:mt-3 lg:mt-3 xl:mt-0 " style={{ alignItems: "flex-start" }}>
                            <div>
                                <img src="assets/locatio2.png" className="w-[60px] md:w-[30px]  2xl:w-[25px] " style={{ height: "26px", }} />
                            </div>
                            <div >
                                <p className="md:w-[12rem] lg:w-[13rem]" style={{}}>
                                    Skyraan Technologies, No.17, Sri Venkateshwara Towers, FCI Rd, opp. Fire Station, Gandhimaa Nagar, Peelamedu, Coimbatore, Tamil Nadu 641004
                                </p>
                            </div>
                        </div>

                    </div>

                    {/* <div>
                        <h6>Get in Touch with Us</h6>
                        <p>Drop in your mail, we’ll reach out to you shortly!</p>
                        <input placeholder="Your email" className="inputArea" id="input" />
                        <br />
                        <button className="sendBtn">Send</button>
                    </div> */}
                </div>

            </div>
        </div>
    );

}

export default Footer;

